import { render, staticRenderFns } from "./UserCandidate.vue?vue&type=template&id=1446bc09&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./UserCandidate.vue?vue&type=script&lang=js"
export * from "./UserCandidate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1446bc09",
  null
  
)

export default component.exports